import Vue from "vue";
import { EcosystemService } from "@/common/api.service";
import {
  FETCH_ECOSYSTEM_APPLICATIONS,
  FETCH_ECOSYSTEM_APPLICATIONS_MAIR,
  FETCH_ECOSYSTEM_LABEL_REFS,
  CREATE_ECOSYSTEM_APP,
  CREATE_ECOSYSTEM_APP_MAIR,
  GET_ECOSYSTEM_FORM_DATA,
  DELETE_ECOSYSTEM_APP,
  SAVE_ECOSYSTEM_FORM,
  GET_ECOSYSTEM_APP_CHECKLIST,
  FETCH_ECOSYSTEM_APPLICATION,
  GET_STRUCTURE_AND_ORGANIZATION,
  UPDATE_ECOSYSTEM_STATUS_APPLICATION,
  GET_ECOSYSTEM_TEAM,
  SEND_ECOSYSTEM_INVITATION,
  GET_BUILDER_FORMS,
  GET_BUILDER_FORM_DATA,
  SAVE_INVESTOR_FORM,
  FETCH_INVESTOR_FORM,
  FETCH_SESSIONLESS_APP_BY_APP_TYPE,
  GET_INVESTOR_DECLARATION,
  DOWNLOAD_INVESTOR_DECLARATION,
  ECOSYSTEM_RESET_STATE
} from "./actions.type";
import {
  SET_FORM_DATA,
  SET_ECOSYSTEM_MENU_ACTIVE,
  SET_ECOSYSTEM_APP,
  SET_ECOSYSTEM_APP_MAIR,
  SET_ERROR,
  PURGE_ERROR,
  SET_STRUCTURE_AND_ORGANIZATION,
  SET_HAS_APPS,
  SET_PROGRESS,
  SET_ECOSYSTEM_TEAM,
  SET_ECOSYSTEM_SESSION,
  SET_STARTUP_APPLICATION,
  RESET_STATE
} from "./mutations.type";
const state = {
  errors: null,
  form: {},
  menu: false,
  app: {},
  hasApps: {
    "Certif": false,
    "Deal": false,
    "Sail": false,
  },
  progress: 0,
  teams: {},
  ecoSession: null
};

const iState = { ...state}

const getters = {
  form(state) {
    return state.form;
  },
  ecosystemMenu(state) {
    return state.menu;
  },
  ecosystemApp(state) {
    return state.app;
  },
  hasApps(state) {
    return state.hasApps;
  },
  ecosystemProgress(state){
    return state.progress
  },
  ecosystemTeam(state){
    return state.teams
  },
  ecosystemSession(state){
    return state.ecoSession
  }
};

const actions = {
  async [FETCH_ECOSYSTEM_APPLICATIONS](context, userId) {
    const { data } = await EcosystemService.getEcosystemApplications(userId);

    return data.data;
  },
  async [FETCH_ECOSYSTEM_APPLICATIONS_MAIR](context, userId) {
    const { data } = await EcosystemService.getEcosystemApplicationsMAIR(userId);

    return data.data;
  },
  async [FETCH_ECOSYSTEM_LABEL_REFS](context, label_ref) {
    const { data } = await EcosystemService.getEcosystemLabelRefs(label_ref);

    return data.data;
  },
  async [CREATE_ECOSYSTEM_APP](context, type) {
    const { data } = await EcosystemService.createEcosystemApplication(type);
    if (['Label','Prélabel'].includes(data.data.application.type)) {
      context.commit(SET_STARTUP_APPLICATION, data.data.application);
    }else{
      context.commit(SET_ECOSYSTEM_APP, data.data);
      context.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
    }
    return data;
  },
  async [CREATE_ECOSYSTEM_APP_MAIR](context, type) {
    const { data } = await EcosystemService.createEcosystemApplicationMair(type);
 
      context.commit(SET_ECOSYSTEM_APP_MAIR, data.data);
      context.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
    
    return data;
  },

  async [GET_ECOSYSTEM_FORM_DATA](context, data) {
    return new Promise((resolve, reject) => {
      EcosystemService.getEcosystemFormData(
        data.type, data.formName, data.hashId
      )
        .then(data => {
          context.commit(SET_FORM_DATA, data.data.data.form);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },

  async [DELETE_ECOSYSTEM_APP](context, id) {
    const { data } = await EcosystemService.deleteEcosystemApplication(id);
    return data;
  },

  async [SAVE_ECOSYSTEM_FORM](context, payload) {
    return new Promise((resolve, reject) => {
      EcosystemService.saveEcosystemForm(payload.form, payload.formName)
        .then(({ data }) => {
          context.commit(SET_FORM_DATA, data.data);
          if (data.meta.errors) context.commit(SET_ERROR, data.meta.errors);
          else context.commit(PURGE_ERROR);
          resolve(data);
        })
        .catch(({ response }) => {
          if (response != undefined)
            context.commit(SET_ERROR, response.data.meta.errors);
          reject(response);
        });
    });
  },

  async [GET_ECOSYSTEM_APP_CHECKLIST](context, hashId) {
    return new Promise((resolve, reject) => {
      EcosystemService.getEcosystemAppChecklist(
        hashId
      )
        .then(data => {
          context.commit(SET_PROGRESS, data.data.data.progress)
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },

  async [FETCH_ECOSYSTEM_APPLICATION](context, hashId) {
    return new Promise((resolve, reject) => {
      EcosystemService.fetchEcosystemApp(
        hashId
      )
        .then(data => {
          context.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
          context.commit(SET_ECOSYSTEM_APP, data.data.data);
          context.commit(SET_ECOSYSTEM_SESSION, data.data.data.session);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },

  async [GET_STRUCTURE_AND_ORGANIZATION](context, id) {
    const { data } = await EcosystemService.getStructureAndOrganization(id);
    context.commit(SET_STRUCTURE_AND_ORGANIZATION, data.data);
    context.commit(SET_ECOSYSTEM_APP, data.data);
    context.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
    return data;
  },

  async [UPDATE_ECOSYSTEM_STATUS_APPLICATION](context, hashId) {
    const { data } = await EcosystemService.updateStatusEcosystemApp(hashId)
    this.state.ecosystem.app.application.status =  parseInt(data.application.status)
    return data
  },

  async [GET_ECOSYSTEM_TEAM](context, hashId) {
    const { data } = await EcosystemService.getEcosystemTeam(hashId);
    context.commit(SET_ECOSYSTEM_TEAM, data.data.teams);
    context.commit(SET_PROGRESS, data.data.progress)
    return data;
  },

  async [SEND_ECOSYSTEM_INVITATION](context, payload) {
    const { data } = await EcosystemService.sendInvitation(payload);
    return data;
  },

  async [GET_BUILDER_FORMS](context) {
    const { data } = await EcosystemService.getBuilderForms();
    return data;
  },

  async [GET_BUILDER_FORM_DATA](context, payload) {
    const { data } = await EcosystemService.getBuilderFormData(payload);
    return data;
  },

  async [SAVE_INVESTOR_FORM](context,payload) {
    const { data } = await EcosystemService.saveInvestorForm(payload);
    return data;
  },

  async [FETCH_INVESTOR_FORM](context,payload) {
    const { data } = await EcosystemService.fetchInvestorForm(payload);
    return data;
  },

  async [GET_INVESTOR_DECLARATION](context,payload) {
    const { data } = await EcosystemService.getInvestorDeclaration(payload);
    return data;
  },

  async [DOWNLOAD_INVESTOR_DECLARATION](context,payload) {
    const { data } = await EcosystemService.downloadInvestorDeclaration(payload);
    return data;
  },

  async [FETCH_SESSIONLESS_APP_BY_APP_TYPE](context, type) {
    return new Promise((resolve, reject) => {
      EcosystemService.fetchSessionlessAppByAppType(
        type
      )
        .then(data => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },

  [ECOSYSTEM_RESET_STATE]({ commit }) {
    commit(RESET_STATE);
  },
};

const mutations = {
  [RESET_STATE]() {
    for (let f in state) {
      Vue.set(state, f, iState[f]);
    }
  },
  [SET_FORM_DATA](state, payload) {
    state.form = payload;
  },
  [SET_ECOSYSTEM_MENU_ACTIVE](state, payload) {
    state.menu = payload;
  },
  [SET_ECOSYSTEM_APP](state, payload) {
    state.app = payload;
  },
  [SET_ECOSYSTEM_APP_MAIR](state, payload) {
    state.app = payload;
  },
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [PURGE_ERROR](state) {
    state.errors = null;
  },
  [SET_STRUCTURE_AND_ORGANIZATION](state, data) {
    if(data){
      state.form = data.form;
    }
  },
  [SET_HAS_APPS](state, data) {
    const EcoAppTypes = ['Deal', 'Sail'];
    state.hasApps['Certif'] = data.hasOwnProperty('Certif') && data['Certif'].length > 0 ? true : false;
    EcoAppTypes.forEach(EcoAppType => {
      if ( data.hasOwnProperty(EcoAppType) && data[EcoAppType].length > 0 && 
      ( data[EcoAppType][data[EcoAppType].length - 1].status == 0 ||
        ['3', '6', '8', '11'].includes(data[EcoAppType][data[EcoAppType].length - 1].status)  && data[EcoAppType][data[EcoAppType].length - 1].result != null && 
        data[EcoAppType][data[EcoAppType].length - 1].parent == data['Certif'][data['Certif'].length - 1].id)) {
        state.hasApps[EcoAppType] = true;
      }else{
        state.hasApps[EcoAppType] = false;
      }
    });
  },
  [SET_PROGRESS](state, data) {
    state.progress = data;
  },
  [SET_ECOSYSTEM_TEAM](state, data) {
    state.teams = data;
  },
  [SET_ECOSYSTEM_SESSION](state, data) {
    state.ecoSession = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
